module.exports = __webpack_public_path__ + "img/tc.d2475843.svg";